
import { Doughnut } from "vue-chartjs";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  extends: Doughnut,
})
export default class ChartDoughnut extends Mixins(Doughnut) {
  @Prop() readonly labels!: Array<string>;
  @Prop() readonly config!: Array<Chart.ChartDataSets>;
  @Prop({
    default: () => {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "index",
        },
      };
    },
  })
  readonly options!: Chart.ChartOptions;

  mounted() {
    this.renderizar();
  }

  @Watch("config")
  @Watch("labels")
  onChange() {
    this.renderChart({
      labels: this.labels,
      datasets: this.config,
    });

    this.renderizar();
    this.$data._chart.update();
  }

  renderizar() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.config,
      },
      this.options
    );
  }
}
